import TomSelect from 'tom-select'
import * as FilePond from 'filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import 'tom-select/dist/css/tom-select.css'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

FilePond.registerPlugin(FilePondPluginFileValidateType)
FilePond.registerPlugin(FilePondPluginImagePreview)
FilePond.registerPlugin(FilePondPluginFileValidateSize)

new TomSelect('#department', false)
registerMultipleSelect('#subject', false)
registerMultipleSelect('#keywords', true)
registerMultipleSelect('#types', true)

function registerMultipleSelect(selector, enableNew) {
    new TomSelect(selector, {
        plugins: ['remove_button'],
        create: enableNew,
        onItemAdd: function () {
            this.setTextboxValue('')
            this.refreshOptions()
        },
    })
}

const inputs = document.querySelectorAll('input[type="file"]')

if (inputs) {
    inputs.forEach((input) => {
        FilePond.create(input, {
            acceptedFileTypes: ['image/png', 'image/jpeg'],
            maxFileSize: '500kb',
            storeAsFile: true,
        })
    })
}
